import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import Header from "./components/Shared/Header";
import Footer from "./components/Shared/Footer";
import { useNavigate } from 'react-router-dom';


const Layout = ({ children, userType }) => {
  const location = useLocation();

  // List of routes where Header and Footer should be excluded
  const excludeHeaderRoutes = ["/", "/login", "/register", "/forgot-password", "/reset-password"];
  const excludeFooterRoutes = ["/", "/login", "/register", "/forgot-password", "/reset-password"];
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event) => {
      // Ensure the message is coming from the iframe
      if (event.data === "navigateToLogin") {
        navigate("/login"); // Navigate to the login page
      }
      if (event.data === "navigateToRegister") {
        navigate("/register"); // Navigate to the login page
      }
    };

    // Listen for messages from iframe
    window.addEventListener("message", handleMessage);

    // Clean up the event listener
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);

  return (
    <div style={styles.layout}>
      {/* Header */}
      {!excludeHeaderRoutes.includes(location.pathname) && (
        <header style={styles.header}>
          <Header userType={userType} />
        </header>
      )}

      {/* Main Content */}
      <main style={styles.main}>{children}</main>

      {/* Footer */}
      {/* {!excludeFooterRoutes.includes(location.pathname) && (
        <footer style={styles.footer}>
          <Footer />
        </footer>
      )} */}
    </div>
  );
};

const styles = {
  layout: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  header: {
    flexShrink: 0, // Prevent the header from shrinking
    backgroundColor: "#f8f9fa", // Example background
    // borderBottom: "1px solid #ccc", // Example border
  },
  main: {
    flex: 1, // Allow main content to take the remaining space
    overflowY: "hidden", // Scroll if content overflows
    // padding: "5px", // Example padding
    // height: "70vh",
    minHeight: "600px", // Default minimum height
    "@media (min-height: 768px)": {
        minHeight: "50vh", // Apply for taller screens
    },
    "@media (min-height: 1024px)": {
        minHeight: "70vh", // Apply for very tall screens
    },
  },
  footer: {
    flexShrink: 0, // Prevent the footer from shrinking
    backgroundColor: "#f8f9fa", // Example background
    borderTop: "1px solid #ccc", // Example border
    textAlign: "center",
  },
  
};

export default Layout;
